import React from 'react'
import { pure } from 'react-recompose'
import Svg from '../shared/Svg'

const Adagio = props => (
  <Svg
    width="35px"
    height="35px"
    viewBox="0 0 35 35"
    {...props}
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-71.000000, -220.000000)">
        <g transform="translate(51.000000, 199.000000)">
          <g transform="translate(20.000000, 21.000000)">
            <circle fill="#FFFFFF" cx="18" cy="19" r="16" />
            <path
              d="M0.00011947053,17.3706899 C0.0714031516,7.72426377 7.93559873,-0.0452559854 17.5822799,0.000198429465 C27.228961,0.0456528443 35.0195888,7.88893691 34.999963,17.5356065 C34.9803372,27.1822761 27.1578604,34.9937965 17.5110742,35 C12.8507102,34.9857361 8.38705188,33.1200019 5.10279617,29.8135481 C1.81854046,26.5070944 -0.0170571527,22.0309964 0.00011947053,17.3706899 M17.6412007,28.5182583 C22.0169919,28.5485264 25.9787733,25.9359065 27.6743308,21.9018521 C29.3698884,17.8677977 28.4642247,13.2093313 25.3807561,10.1043814 C22.2972876,6.99943162 17.645226,6.06145444 13.5995058,7.72897348 C9.55378546,9.39649253 6.91373382,13.3400501 6.91362914,17.7159521 C6.89590918,23.6600726 11.6971088,28.4947202 17.6412007,28.5182583"
              fill="#ec004a"
              fillRule="nonzero"
            />
          </g>
        </g>
      </g>
    </g>
  </Svg>
)

export default pure(Adagio)
